import { CustomerArticleLicenceDTO, IArticleLicencingClient, ArticleLicencingClient, AccountArticleLicenceDTO } from "@/Generated/ParticaAPI";
import { IArticle, Article } from "@/Models/ArticleModels/article";

export interface IArticleLicenceService {
	getLicences(accountID: number): Promise<CustomerArticleLicenceDTO[]>;
	saveLicence(licence: CustomerArticleLicenceDTO): Promise<CustomerArticleLicenceDTO>;
	makeDefault(accountId: number, licenceId: number): Promise<any>;
	getProofArticles(accountID: number): Promise<AccountArticleLicenceDTO[]>;
	UpdateArticleLicences(accountId: number, articles: number[], licenceId: number): Promise<any>;
}

export class ArticleLicenceService implements IArticleLicenceService {
	private svc: IArticleLicencingClient = new ArticleLicencingClient();

	public async UpdateArticleLicences(accountId: number, articles: number[], licenceId: number): Promise<any> {
		return await this.svc.updateArticleLicences(accountId, articles, licenceId);
	}

	public async makeDefault(accountId: number, licenceId: number): Promise<any> {
		return await this.svc.makeDefault(accountId, licenceId);
	}

	public async saveLicence(licence: CustomerArticleLicenceDTO): Promise<CustomerArticleLicenceDTO> {
		return await this.svc.saveAccountLicence(licence);
	}

	public async getLicences(accountID: number): Promise<CustomerArticleLicenceDTO[]> {
		const licences = await this.svc.getAccountLicences(accountID);
		return licences;
	}

	public async getProofArticles(accountID: number): Promise<AccountArticleLicenceDTO[]> {
		const licences = await this.getLicences(accountID);
		const proofarticles = await this.svc.getArticlesInProof(accountID);
		proofarticles.forEach(art => {
			if (art !== null) {
				const lic = licences.find(l => l.customerArticleLicenceId === art.licenceId);
				if (lic !== undefined) {
					art.licenceName = lic.name;
				}
			}
		});
		return proofarticles;
	}
}
